<div class="row center-center header container">
  <div class="item grow header__card">
    <div class="column grow with-gap justify-space-evenly header-content">
      @if (loading) {
        <div class="row grow center-center">
          <div class="loadingSpinner"></div>
        </div>
      }
      @if (!loading) {
        <div class="column with-gap center-center">
          <h4>
            {{ "Shell.generic.location" | translate }}
          </h4>
          <span class="underlined">{{ site?.city }}, {{ site?.country }}</span>
        </div>
      }
    </div>
  </div>

  <div class="item grow header__card">
    <div class="column grow with-gap justify-space-evenly header-content">
      @if (loading) {
        <div class="row grow center-center">
          <div class="loadingSpinner"></div>
        </div>
      }
      @if (!loading) {
        <div class="column with-gap center-center">
          <h4>
            {{ "Shell.generic.size" | translate }}
          </h4>
          <span class="underlined">{{ site?.area?.value }} {{ site?.area?.symbol }}</span>
        </div>
      }
    </div>
  </div>

  <div class="item grow header__card">
    <div class="column grow with-gap justify-space-evenly header-content">
      @if (loading) {
        <div class="row grow center-center">
          <div class="loadingSpinner"></div>
        </div>
      }
      @if (!loading) {
        <div class="column with-gap center-center">
          <h4>
            {{ "Shell.generic.crops" | translate }}
          </h4>
          <div class="row with-gap align-items-center">
            <span class="underlined">{{ site?.activeCropCyclesCount }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
